import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { deserialize } from 'serialize-ts';
import { BadRequestHttpError, GeneralHttpError, ImsHttpError } from '../models';
import { HttpErrorStatuses } from '../constants/http-error-statuses.enum';
import { HttpErrorHandler } from '../services/http-error-handler.service';

const BUYER_ACCOUNT_SELF_SERVICE_URL_PART = 'buyer-account/self-service';
const BUYER_ACCOUNT_ADD_BUSINESS_URL = 'api/v1/business-account';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private httpErrorHandler: HttpErrorHandler,
  ) {}

  private static transformError(error: HttpErrorResponse): GeneralHttpError | BadRequestHttpError | ImsHttpError {
    switch (error.status) {
      case HttpErrorStatuses.BadRequest:
        return deserialize(error.error, BadRequestHttpError);

      case HttpErrorStatuses.IMSError:
        return deserialize(error.error, ImsHttpError);

      default:
        return deserialize(error.error, GeneralHttpError);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.url &&
            (error.url.indexOf(BUYER_ACCOUNT_SELF_SERVICE_URL_PART) === -1 && 
             error.url.indexOf(BUYER_ACCOUNT_ADD_BUSINESS_URL) === -1)
        ) {
          const httpError = error && HttpErrorInterceptor.transformError(error);
          httpError.sourceError = error;
          this.httpErrorHandler.handleError(httpError);
          return throwError(httpError);
        } else {
          return throwError(error);
        }
      })
    );
  }
}
